export default __webpack_public_path__ + "35fdc830eccfd47c2d0321e533a153e0.webp";